import { useI18N } from "@sundae/react-hooks";
import { useMemo } from "react";
import { ADA_METADATA } from "../../constants/cardano.constants";
import { useTasteTestContext } from "../../pages/TasteTestDetail/context";
import { EOrderFlowState, useOrderContext } from "../../stores/OrderContext";
import { getAssetName } from "../../utils/assets.utils";

export const useTasteTestContributeWidgetTitle = () => {
  const { t } = useI18N("taste-test");
  const {
    state: {
      flowData: { flowState },
    },
  } = useOrderContext();
  const {
    derived: { hasContribution },
    state: { actionType },
  } = useTasteTestContext();

  const isInitialFlowState = [
    EOrderFlowState.initial,
    EOrderFlowState.previewCancelled,
    EOrderFlowState.reset,
  ].includes(flowState);

  return useMemo(() => {
    /* -------------------------------------------------------------------------------------------------
     * TITLES FOR INITIAL VIEW
     * -----------------------------------------------------------------------------------------------*/
    if (isInitialFlowState) {
      /**
       * UPDATE
       */
      if (hasContribution && isInitialFlowState) {
        return t("detail.widget.title.initial.update", {
          token: getAssetName(ADA_METADATA),
        });
      }
      /**
       * DEPOSIT
       */
      if (actionType === "deposit" && isInitialFlowState) {
        return t("detail.widget.title.initial.deposit");
      }
      /**
       * WITHDRAW
       */
      if (actionType === "withdraw" && isInitialFlowState) {
        return t("detail.widget.title.initial.withdraw");
      }
      /* -------------------------------------------------------------------------------------------------
       * TITLES FOR ORDER PREVIEW
       * -----------------------------------------------------------------------------------------------*/
    } else if ([EOrderFlowState.preview, EOrderFlowState.submittingCancelled].includes(flowState)) {
      /**
       * UPDATE
       */
      if ((hasContribution && actionType === "deposit") || actionType === "update") {
        return t("detail.widget.title.orderPreview.update");
      }
      /**
       * DEPOSIT
       */
      if (!hasContribution && actionType === "deposit") {
        return t("detail.widget.title.orderPreview.deposit");
      }
      /**
       * WITHDRAW
       */
      if (actionType === "withdraw") {
        return t("detail.widget.title.orderPreview.withdraw");
      }
      /* -------------------------------------------------------------------------------------------------
       * TITLES FOR SUBMITTING
       * -----------------------------------------------------------------------------------------------*/
    } else if (flowState === EOrderFlowState.submitting) {
      /**
       * UPDATE
       */
      if ((hasContribution && actionType === "deposit") || actionType === "update") {
        return t("detail.widget.title.submitting.update");
      }
      /**
       * DEPOSIT
       */
      if (!hasContribution && actionType === "deposit") {
        return t("detail.widget.title.submitting.deposit");
      }
      /**
       * WITHDRAW
       */
      if (actionType === "withdraw") {
        return t("detail.widget.title.submitting.withdraw");
      }
      /* -------------------------------------------------------------------------------------------------
       * TITLES FOR SUCCESS
       * -----------------------------------------------------------------------------------------------*/
    } else if (flowState === EOrderFlowState.success) {
      return t("detail.widget.title.success");
      /* -------------------------------------------------------------------------------------------------
       * TITLES FOR ERROR
       * -----------------------------------------------------------------------------------------------*/
    } else if (flowState === EOrderFlowState.error) {
      return t("detail.widget.title.error");
    }

    return "";
  }, [actionType, flowState, isInitialFlowState, t, hasContribution]);
};
